export default {
	STORAGE_URL: process.env.VUE_APP_STORAGE,
	storage(...paths) {
		return `${this.STORAGE_URL}${paths.join("")}`;
	},
};
